import React from 'react';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import Typography from '@mui/material/Typography';

class ListItemContentSummary2 extends React.Component {

  render() {
    const { classes, children, className, ...others } = this.props;
    const innerProps = { className: clsx(classes.content, className), component: "div", variant: "body2" };
    return (
      <Typography {...{...innerProps, ...others}}>{children}</Typography>
    )
  }
}

const styles = theme => ({
  content: {
    color: theme.palette.primary.main
  },
});

export default withStyles(styles, { withTheme: true })(ListItemContentSummary2);
